import AppRoutes from './core/AppRoutes';
import { BrowserRouter as Router } from 'react-router-dom';
import { useEffect } from 'react';
import { loadScript } from './core/helpers';
import { HOTJAR_SCRIPT_INNER_HTML, IsProduction } from './core/constants';
import BookMeetingModal from './components/BookMeetingModal/BookMeetingModal';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useTranslation } from 'react-i18next';

const App = () => {
  const { vs3373Hotjar } = useFlags();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (process.env.REACT_APP_ENV && process.env.REACT_APP_ENV !== 'prod') {
      const favicon = document.getElementById('favicon')!;
      const appleFavicon = document.getElementById('apple-favicon')!;
      (favicon as HTMLLinkElement).href =
        process.env.PUBLIC_URL + '/logo192-env.png';
      (appleFavicon as HTMLLinkElement).href =
        process.env.PUBLIC_URL + '/logo192-env.png';
    }
  }, []);

  useEffect(() => {
    if (process.env.REACT_APP_ENV !== 'prod') {
      const head = document.head;

      const script = document.createElement('script');
      script.setAttribute('id', 'CookieBot');
      script.setAttribute('src', 'https://consent.cookiebot.com/uc.js');
      script.setAttribute('data-cbid', '5ba2f28f-df61-4e9f-bc9f-e78e9f8d2bb0');
      script.setAttribute('type', 'text/javascript');
      script.setAttribute('async', 'true');
      script.setAttribute('data-culture', i18n.language.toUpperCase());
      head.insertBefore(script, head.firstChild);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const onCookieAccept = (e: any) => {
      if (
        IsProduction &&
        vs3373Hotjar &&
        window.Cookiebot?.consent.statistics
      ) {
        loadScript({ async: true, innerHTML: HOTJAR_SCRIPT_INNER_HTML });
      }
    };

    window.addEventListener('CookiebotOnAccept', onCookieAccept, false);

    return () => {
      window.removeEventListener('CookiebotOnAccept', onCookieAccept, false);
    };
  }, [vs3373Hotjar]);

  return (
    <>
      <Router>
        <AppRoutes />
      </Router>
      <BookMeetingModal />
    </>
  );
};

export default App;
